import { useFloating, autoUpdate, offset, flip, shift } from '@floating-ui/react-dom';
import { useEffect } from 'react';

function usePosition(props) {
  const floating = useFloating({
    strategy: "fixed",
    open: props.active,
    placement: props.placement ?? "bottom-end",
    whileElementsMounted: autoUpdate,
    middleware: [offset(props.offsetPx ?? 10), flip({
      padding: 15
    }), shift({
      padding: 15
    })]
  });
  useEffect(() => {
    floating.refs.setReference(props.triggerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [floating.refs, props.triggerRef.current]);
  return floating;
}

export { usePosition };
//# sourceMappingURL=hook.position.js.map
